import React from "react";

const NextArrow = (props) =>
{
return(
    <button className="NextArrow"><i className="ri-arrow-right-s-line" onClick={props.onClick}></i></button>
);

}

export default NextArrow